"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProjectErrorResponse = exports.transformOnlinePaymentsErrorResponse = exports.transformEventErrorResponse = exports.transformAuthErrorResponse = exports.transformAccountingErrorResponse = exports.isProjectErrorResponse = exports.isOnlinePaymentErrorResponse = exports.isEventErrorResponse = exports.isAuthErrorResponse = exports.isAccountingErrorResponse = exports.APIClientConfigError = void 0;
class APIClientConfigError extends Error {
}
exports.APIClientConfigError = APIClientConfigError;
class APIClientError extends Error {
    constructor(name, message, statusCode, errors) {
        super();
        this.name = name;
        this.message = message;
        this.statusCode = statusCode;
        this.errors = errors;
    }
}
exports.default = APIClientError;
function isAccountingErrorResponse(status, response) {
    if (parseInt(status) >= 400 ||
        (response.response && response.response.error) ||
        (response.response && response.response.errors) ||
        (response.code && response.message && response.details)) {
        return true;
    }
    return false;
}
exports.isAccountingErrorResponse = isAccountingErrorResponse;
function isAuthErrorResponse(status, response) {
    if (parseInt(status) >= 400 || response.error || response.error_description) {
        return true;
    }
    return false;
}
exports.isAuthErrorResponse = isAuthErrorResponse;
function isEventErrorResponse(status) {
    return parseInt(status) >= 400;
}
exports.isEventErrorResponse = isEventErrorResponse;
function isOnlinePaymentErrorResponse(status, response) {
    if (parseInt(status) >= 400 || response.error_type) {
        return true;
    }
    return false;
}
exports.isOnlinePaymentErrorResponse = isOnlinePaymentErrorResponse;
function isProjectErrorResponse(status, response) {
    if (parseInt(status) >= 400 || response.error || response.errno) {
        return true;
    }
    return false;
}
exports.isProjectErrorResponse = isProjectErrorResponse;
const transformAccountingErrorResponse = (errorResponse) => {
    const { response } = errorResponse;
    if (response && response.errors) {
        return {
            errors: response.errors.map(({ message: msg, errno: errorCode, field, object, value }) => ({
                message: msg,
                errorCode,
                field,
                object,
                value,
            })),
        };
    }
    if (errorResponse.code && errorResponse.message && errorResponse.details) {
        // New style accounting errors
        const errors = [];
        errorResponse.details.forEach((detail) => {
            if (detail['@type'] == 'type.googleapis.com/google.rpc.ErrorInfo') {
                errors.push({
                    message: detail.metadata.message,
                    errorCode: parseInt(detail.reason),
                    field: detail.metadata.field,
                    object: detail.metadata.object,
                    value: detail.metadata.value,
                });
            }
        });
        if (errors.length)
            return { errors };
    }
    return {
        message: 'Returned an unexpected response',
    };
};
exports.transformAccountingErrorResponse = transformAccountingErrorResponse;
const transformAuthErrorResponse = (errorResponse) => {
    if (errorResponse.error && errorResponse.error_description) {
        return {
            message: errorResponse.error_description,
        };
    }
    return {
        message: 'Returned an unexpected response',
    };
};
exports.transformAuthErrorResponse = transformAuthErrorResponse;
const transformEventErrorResponse = (errorResponse) => {
    const { message, details } = errorResponse;
    if (message && details) {
        const errors = [];
        const badRequest = details.find((detail) => detail.fieldViolations);
        if (badRequest) {
            badRequest.fieldViolations.forEach((error) => {
                errors.push({
                    field: error.field,
                    message: error.description,
                });
            });
            return { errors };
        }
    }
    if (message)
        return { message };
    return {
        message: 'Returned an unexpected response',
    };
};
exports.transformEventErrorResponse = transformEventErrorResponse;
const transformOnlinePaymentsErrorResponse = (errorResponse) => {
    const { error_type: errorType, message } = errorResponse;
    if (errorType && message) {
        return {
            message,
        };
    }
    return {
        message: 'Returned an unexpected response',
    };
};
exports.transformOnlinePaymentsErrorResponse = transformOnlinePaymentsErrorResponse;
const transformProjectErrorResponse = (errorResponse) => {
    const { error, errno, message } = errorResponse;
    if (error && errno) {
        return {
            errors: Object.keys(error).map((key) => ({
                errorCode: errno,
                field: key,
                message: error[key],
            })),
        };
    }
    if (error) {
        return {
            message: error,
        };
    }
    if (message) {
        return {
            message: message,
        };
    }
    return {
        message: 'Returned an unexpected response',
    };
};
exports.transformProjectErrorResponse = transformProjectErrorResponse;
//# sourceMappingURL=Error.js.map